import { O, pipe, RA } from '@packages/prelude'
import * as domain from '@packages/domain'

type Bound = domain.Meta.Fields.PersonalizationField.Bound

// Pair each personalization field of a bound kind with the IndiAudio parameter named by its
// explicit parameterId, narrowed by `isParam` to the arm that kind binds to. Fields whose
// parameter is absent — or of the wrong arm — are dropped.
export const bindFieldsByParameterId =
  <K extends Bound['kind'], P extends domain.IAParameter.Type>(kind: K, isParam: (p: domain.IAParameter.Type) => p is P) =>
  (
    meta: domain.Meta.ProductPersonalization.Type,
    parameters: ReadonlyArray<domain.IAParameter.Type>
  ): ReadonlyArray<readonly [Extract<Bound, { kind: K }>, P]> =>
    pipe(
      meta,
      domain.Meta.ProductPersonalization.fieldsOfKind(kind),
      RA.filterMap(field =>
        pipe(
          parameters,
          domain.IAParameters.byId(field.parameterId),
          O.filter(isParam),
          O.map(param => [field, param] as const)
        )
      )
    )
